import axiosClient from './axiosClient';

export const HOMEPAGE_KEY = ["homepage"];

const homepageApi = {
  getText: () => axiosClient.get('/homepage/last'),
  createText: (description: string) => axiosClient.post('/homepage', { description }),  
  updateText: (description: string, id: string) => axiosClient.patch(`/homepage/${id}`, { description }),
};

export default homepageApi;